import { useMemo } from 'react'
import _ from 'lodash'
import { SamplePartsTab } from '../../types'
import { defaultTheme } from '@agro-club/agroclub-shared'

// may be we can use backend colors without alpha
const groupsColorMap = {
  beaten: defaultTheme.color.accentNotify16a,
  defective: defaultTheme.color.primary16a,
  gauge: defaultTheme.color.accentApprove16a,
  grain_admixture: defaultTheme.color.secondary16a,
  various_admixture: defaultTheme.color.accentApprove16a,
  defective_seeds: defaultTheme.color.accentApprove16a,
  weed_admixture: defaultTheme.color.primary16a,
  oil_admixture: defaultTheme.color.accentApprove16a,
  essential_oil_admixture: defaultTheme.color.accentApprove16a,
  average: '#fef9d9', // use color without alpha, to prevent transparency for fixed columns
}

const getCommonOnCell = (fileldId) => {
  return (record) => commonOnCell(fileldId, record)
}
const commonOnCell = (fileldId, record) => {
  if (record[fileldId].color_group) {
    return {
      style: {
        backgroundColor: groupsColorMap[record[fileldId].color_group],
      },
    }
  }
  return {}
}

const columnsWidthMap = {
  parameters_added_date: 106,
  warehouse_name: 100,
  pile_part_number: 84,
  note: 300,
  additional_comment: 200,
}

const nonParamsFields = ['parameters_added_date', 'warehouse_name', 'pile_part_number', 'note', 'additional_comment']

export const useColumns = (tabData: SamplePartsTab) => {
  return useMemo(
    () =>
      tabData.headers.map((h, index) => ({
        title: h.text,
        dataIndex: h.field_id,
        width: columnsWidthMap[h.field_id] || 120,
        align: (nonParamsFields.includes(h.field_id) ? 'left' : 'right') as any,
        fixed: index < 3 ? true : false,
        render: (item) => item.text,
        onCell: getCommonOnCell(h.field_id),
        onHeaderCell: () => {
          if (h.color_group) {
            return {
              style: {
                backgroundColor: groupsColorMap[h.color_group],
              },
            }
          }
          return {}
        },
      })),
    [tabData.headers],
  )
}

export const useSampleTableData = (tabData: SamplePartsTab) => {
  return useMemo(
    () =>
      tabData.data.map((dataRow) => {
        const rowForTable = {}
        tabData.headers.forEach((h, index) => {
          rowForTable[h.field_id] = dataRow[index]
        })
        return rowForTable
      }),
    [tabData.data, tabData.headers],
  )
}
